import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 're-mymatrix-confirmation-dialog',
    templateUrl: './mymatrix-confirmation-dialog.component.html',
    styleUrls: ['./mymatrix-confirmation-dialog.component.scss'],
    standalone: false
})
export class MymatrixConfirmationDialogComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private router: Router) { }
  message: { message: string };
  ngOnInit(): void {
  }

  close() {
    this.activeModal.close(false);
  }

}
